import { GENRES } from "@/data/content";

export default function Marquee({ items = GENRES, className = "" }) {
  return (
    <div className={`overflow-hidden py-8 ${className}`} data-testid="genre-marquee" aria-hidden="true">
      <div className="-mx-4 -rotate-[1.3deg] bg-glow py-3 sm:py-4">
        <div className="marquee-track flex w-max items-center gap-7 whitespace-nowrap pr-7">
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center gap-7">
              {[...items, ...items].map((item, i) => (
                <span key={`${half}-${i}`} className="flex items-center gap-7">
                  <span className="font-clash text-xl font-semibold uppercase tracking-tight text-night sm:text-2xl">
                    {item}
                  </span>
                  <span className="h-2 w-2 rotate-45 bg-night" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
